<div class="row mb">
  <div class="col col-md-12">
    <pr-input-column
      label="Evaluation de votre patrimoine global net"
      [derrors]="derrors"
      [isDefault]="false"
      [suffix]="'€'"
    >
      <input notdot formControlName="distributionEvaluation" type="number" />
    </pr-input-column>
  </div>
</div>
@if (error && derrors) {
  <info [option]="optionInfo1">
    {{ error.message }}
  </info>
}

<distribution-assets
  formArrayName="distributionAssets"
  [derrors]="derrors"
></distribution-assets>
